import { Text } from '@factorialco/deprecated-design-system'

export const SyncStatus: React.FC<{ externalId?: string | null }> = ({ externalId }) => {
  if (!externalId) {
    return null
  }

  return (
    <Text.Normal size="200" lineClamp={1}>
      {externalId}
    </Text.Normal>
  )
}
